<!-- =========================================================================================
  File Name: MemberAdd.vue
  Description: Member Add Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-member-add">

    <vx-card title="회원 상세 정보" class="mb-base" >
      <member-add-form class="mt-4" />
    </vx-card>

  </div>
</template>

<script>
import MemberAddForm  from './MemberAddForm'

export default {
  components: {
    MemberAddForm
  },
  data () {
    return {
    }
  },
  watch: {
  },
  methods: {
  }
}

</script>
